/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../nls/StringResources',
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'@ba/ba-graphics/dist/icons-js/close_16'
], function (_, stringResources, React, PropTypes, Toolkit, close_button) {

	const {
		FlexLayout,
		FlexItem,
		Label,
		SVGIcon,
		TruncatedText
	} = Toolkit;

	class NextViewComponent extends React.Component {
		static propTypes = {
			targetCaption: PropTypes.string,
			name: PropTypes.string,
			hideFn: PropTypes.func
		}

		constructor(props) {
			super(props);
			//this.state = this._buildStateFromProps();
		}

		render() {
			//<TruncatedText value={this.props.targetCaption}/>
			if (this.props.targetCaption) {
				return this._renderWithTargetCaption();
			} else {
				return this._renderWithNoTargetCaption();
			}
		}

		//This version of render renders a (possibly truncated) column Name with close button
		//Followed by the next view title heading.
		_renderWithTargetCaption() {
			return (
				<FlexLayout
					className='nextViewComponent'
					fullHeight
					direction='column'
					justifyContent='space-between'
				>
					<FlexLayout
						className='targetCaptionAndClose'
						direction='row'
					>
						<FlexItem
							grow
							className='aTargetCaption'
							value={this.props.targetCaption}
							type='caption'
						>
							<TruncatedText value={this.props.targetCaption} />
						</FlexItem>
						{this._renderCloseButton()}
					</FlexLayout>
					<Label
						className='aActionName'
						label={this.props.name}
						type='caption'
					/>
				</FlexLayout>
			);
		}

		//This version of render renders the view title heading with close button
		_renderWithNoTargetCaption() {
			return (
				<FlexLayout
					className='nextViewComponent'
					fullHeight
					direction='column'
					justifyContent='space-between'
				>
					<FlexLayout
						className='actionNameAndClose'
						direction='row'
					>
						<FlexItem
							grow
							value={this.props.name}
							type='caption'>
							<Label
								className='aActionName'
								label={this.props.name}
								type='caption'
							/>
						</FlexItem>
						{this._renderCloseButton()}
					</FlexLayout>
				</FlexLayout>
			);
		}

		_renderCloseButton() {
			return (
				<SVGIcon
					iconId={close_button.default.id}
					tabIndex='0'
					onClick={this.props.hideFn}
					onKeyUp={(evt) => this._handleKeyUp(evt)}
					aria-label={stringResources.get('dlg_close')}
				/>
			);
		}

		_handleKeyUp = (evt) => {
			if(evt.keyCode === 32 || evt.keyCode === 13) {
				this.props.hideFn();
				evt.stopPropagation();	//If we dont stopPropagation, slot editor A11Y will re-open the action menu which is in focus!
			}
		}
	}

	return NextViewComponent;
});
